import React, { useEffect, useState } from 'react'
import Slider from 'react-slick'
import styled from 'styled-components'
import { Container } from 'react-bootstrap'
import { ArrowRight } from '../../../ui/AllImages'
import { ContactButton } from '../../../ui/CustomElements'
import { Box } from '../../../ui/Elements'
import { useTranslation } from 'react-i18next'

const bannerSlides = [
    { slideClass: 'indonesiaSlide', thumbClass: 'indonesiaThumb', landmarkKey: 'Borobudur', countryKey: 'Indonesia' },
    { slideClass: 'malaysiaSlide', thumbClass: 'malaysiaThumb', landmarkKey: 'TwinTowers', countryKey: 'Malaysia' },
    { slideClass: 'azerbaijanSlide', thumbClass: 'azerbaijanThumb', landmarkKey: 'FlameTowers', countryKey: 'Azerbaijan' },
    { slideClass: 'turkeySlide', thumbClass: 'turkeyThumb', landmarkKey: 'Uzungol', countryKey: 'NorthernTurkey' },
    { slideClass: 'georgiaSlide', thumbClass: 'georgiaThumb', landmarkKey: 'JvariMonastery', countryKey: 'Georgia' },
    { slideClass: 'moscowSlide', thumbClass: 'moscowThumb', landmarkKey: 'SaintBasils', countryKey: 'Moscow' },
]

const AsNavFor = () => {
    const { t } = useTranslation();
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    const [slider1, setSlider1] = useState(null);
    const [slider2, setSlider2] = useState(null);

    const WhatsApp = () => {
        const phoneNumber = '+966535316584';
        const whatsappURL = `https://wa.me/${phoneNumber}`;
        window.open(whatsappURL, '_blank');
    };

    useEffect(() => {
        setNav1(slider1);
        setNav2(slider2);
    }, [slider1, slider2]);

    const SliderSetting = {
        infinite: true,
        fade: true,
        speed: 900,
        cssEase: 'cubic-bezier(0.22, 1, 0.36, 1)',
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: false,
        swipe: false,
        waitForAnimate: true,
    };

    const SliderSettingTh = {
        dots: false,
        infinite: true,
        nextArrow: false,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: false,
        pauseOnHover: false,
        swipe: false,
        responsive: [
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
                breakpoint: 640,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  className: "center",
                    centerMode: true,
                }
            }
          ]
    };

    return (
            <>
                <BannerWapper className='container-fluid banner-bg' id='home'>
                    <Box className='banner-wapper-card'>
                        <Slider {...SliderSetting}
                            asNavFor={nav2}
                            ref={(slider) => (setSlider1(slider))}
                            >
                            {bannerSlides.map((slide) => (
                                <Box key={slide.slideClass} className={`container-fluid mainSlide ${slide.slideClass}`}>
                                    <Box className='slideMedia' aria-hidden='true' onClick={WhatsApp} />
                                    <Container className='containerMainSlider'>
                                        <Box className='sliderContentWrapper'>
                                            <Box className='sliderHeading'>
                                                {t('Start_your_journey')}
                                            </Box>
                                            <Box className='sliderdetail'>
                                                {t('sliderSubHeading')}
                                            </Box>
                                            <ContactButton className='sliderBtn' icon={ArrowRight} label={t('BookNow')} onClick={WhatsApp} />
                                        </Box>
                                    </Container>
                                </Box>
                            ))}
                        </Slider>
                        <Box className='thumbnailSlides'>
                            <Slider {...SliderSettingTh}
                                asNavFor={nav1}
                                ref={(slider) => (setSlider2(slider))}
                                slidesToShow={3}
                                swipeToSlide={true}
                                focusOnSelect={true}
                                >
                                {bannerSlides.map((slide) => (
                                    <Box key={slide.thumbClass} className={`container-fluid mainThumb ${slide.thumbClass}`}>
                                        <Container>
                                            <Box className='sliderThumbWrapper'>
                                                <Box className='sliderThumbDetail'>
                                                    {t(slide.landmarkKey)}
                                                </Box>
                                                <Box className='sliderThumbHeading'>
                                                    {t(slide.countryKey)}
                                                </Box>
                                            </Box>
                                        </Container>
                                    </Box>
                                ))}
                            </Slider>
                        </Box>
                    </Box>
                </BannerWapper >
            </>
        );
    };
    
export default AsNavFor;
    
const BannerWapper = styled.section`
    perspective: 1400px;
    .banner-wapper-card{
        position: relative;
        height: 100%;
        transform-style: preserve-3d;
    }
    .banner-card{
        padding-top:70px;
        display: flex !important;
        align-items: center;
        justify-content: space-between;
    }
    .banner-text-card{
        display: flex;
        flex-direction: column;
        gap:20px;
        width: 56%;
    }

`
